import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const QCOfficerRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/QC-officer/qc-dashboard/qc-dashboard').then(
        (m) => m.QCDashboard
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'QC Officer',
    },
  },
  {
    path: 'dashboard/interview-details/:id',
    loadComponent: () =>
      import('@pages/QC-officer/interviewer-details/interviewer-details').then(
        (m) => m.InterviewerDetails
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'QC Officer',
    },
  },
  {
    path: 'dashboard/interview-report/:projectId/:interviewerId',
    loadComponent: () =>
      import('@pages/QC-officer/survey-report/survey-report').then(
        (m) => m.SurveyReport
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'QC Officer',
    },
  },
];
